import { IApiClient, getApiClient } from "@/api/ApiClient/ApiClient";
import { Reference } from "@/models/APIModels/Reference";
import { ReferenceViewModel } from "@/models/ViewModels/ReferenceModel";
import logger, { LoggingSource } from "@/shared/Logger";
import IResponseModel from "./ResponseModel";

export default class ReferenceApi {
  private readonly _apiClient: IApiClient;
  private readonly URL: string = "/reference";

  constructor(apiClient: IApiClient = getApiClient()) {
    this._apiClient = apiClient;
  }

  async getAll(): Promise<IResponseModel<ReferenceViewModel>> {
    try {
      logger.info("getAll...", LoggingSource.UIReferenceData);

      logger.timeStart("getReference call", LoggingSource.UIReferenceData);
      const result = await this._apiClient.get<string>(this.URL);
      logger.timeEnd("getReference call", LoggingSource.UIReferenceData);
      logger.debug(
        `getReferenceData reference data: ${JSON.stringify(result)}`,
        LoggingSource.UIReferenceData
      );
      let reference: IResponseModel<ReferenceViewModel> = {
        ...result,
      } as IResponseModel<ReferenceViewModel>;

      if (result.content) reference.content = JSON.parse(result.content);

      return reference;
    } catch (error) {
      logger.timeEnd("getReference call", LoggingSource.UIReferenceData);
      logger.error(JSON.stringify(error), LoggingSource.UIReferenceData);
      throw error;
    } finally {
      logger.info("...getAll", LoggingSource.UIReferenceData);
    }
  }
}
